import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import I18n from 'PMT/i18n/I18n';

import {
  Product,
  RestaurantMenu
} from 'PMT/entities/menu';

import {
  Utils,
  ArrayUtils,
  StringUtils
} from 'PMT/utils';

import { Modal } from 'react-bootstrap';
import { TextInput } from 'PMT/components/form';
import SearchBox from 'PMT/components/SearchBox';
import ProductItem from './ProductItem';

/**
*/
export default class ChooseProductsModal extends Component {

  static defaultProps = {
    selectedProducts: []
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,

    /**
    * @param Array<Product>
    */
    onChooseProducts: PropTypes.func.isRequired,

    selectedProducts: PropTypes.arrayOf(Product)
  };

  state = {
    searchQuery: '',

    selectedProducts: this.props.selectedProducts.slice()
  };

  onSubmit = () => {
    this.props.onChooseProducts(this.state.selectedProducts);
  };

  onToggleProduct = (product:Product) => {
    const selectedProducts = ArrayUtils.toggleObject(
      this.state.selectedProducts,
      product,
      { id: product.id }
    );

    this.setState({
      selectedProducts
    });
  };

  onSearchQueryChange = (searchQuery:string) => {
    this.setState({
      searchQuery
    });
  };

  renderList() {
    let listView = null;

    const products = [];
    _.each(this.props.restaurantMenu.products, (product:Product) => {
      const query: string = this.state.searchQuery;
      if (_.isEmpty(query) || StringUtils.searchStringOn(query, product.name)) {
        products.push(product);
      }
    });

    if (_.isEmpty(products) && !_.isEmpty(this.state.searchQuery)) {
      return (
        <p>
          <em>
            {I18n.tr('components.menu.choose_product_modal.search_no_results')}
          </em>
        </p>
      );
    }

    // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
    const sortedProductsList = _.sortBy(products, ['desc'],
    (product: Product): number => {
      return StringUtils.toAlphaNum(product.name).toLowerCase();
    });

    listView = sortedProductsList.map((product:Product) => {
      return (
        <ProductItem
          key={product.id}
          product={product}
          isSelected={ArrayUtils.exists(this.state.selectedProducts, { id: product.id })}
          onToggle={this.onToggleProduct}
        />
      );
    });

    return (listView);
  }

  renderBody() {
    return (
      <div className="choose_products_modal">
        <SearchBox
          search={this.state.searchQuery}
          onSearchInput={this.onSearchQueryChange}
        />
        <div className="list">
          {this.renderList()}
        </div>

        <div className="text-center">
          <button
            className="btn btn-primary"
            onClick={this.onSubmit}
          >
            {I18n.tr('global.validate')}
          </button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Modal
        bsSize="sm"
        show={this.props.show}
        onHide={this.props.onHide}
        backdrop="static"
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.props.onHide}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {I18n.tr('components.menu.choose_product_modal.choose_products')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}
